import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from '@a-type/ui';
import { withGame } from '@long-game/game-client';
import { useEffect, useState, } from 'react';
import { Droppable } from '../dnd/Droppable.js';
import { useDndStore } from '../dnd/dndStore.js';
import cls from './ChatSurface.module.css';
import { SpatialChatThread } from './SpatialChatThread.js';
const droppableTags = ['spatial-chat-surface'];
export const ChatSurface = withGame(function ChatSurface({ sceneId, children, className, gameSuite, disabled, svg, render, ...rest }) {
    const chats = gameSuite.getSceneChat(sceneId);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        gameSuite.loadMoreChat(sceneId);
    }, [gameSuite, sceneId]); // Load more chats when the component mounts or scene changes
    const handleDrop = (draggable) => {
        if (draggable.id !== 'spatial-chat')
            return;
        setOpen(true);
    };
    const isSpatialChatDragging = useDndStore((state) => state.dragging === 'spatial-chat');
    if (disabled) {
        if (svg) {
            return (_jsx("g", { className: className, ...rest, children: children }));
        }
        return (_jsx("div", { className: className, ...rest, children: children }));
    }
    return (_jsxs(Droppable, { noParenting: true, id: sceneId, onDrop: handleDrop, accept: (draggable) => {
            return draggable.id === 'spatial-chat';
        }, className: clsx(cls.root, className), "data-dragging": isSpatialChatDragging, render: render, tags: droppableTags, svg: svg, children: [children, _jsx(SpatialChatThread, { chats: chats, className: cls.thread, open: open, onOpenChange: setOpen, sceneId: sceneId, svg: svg })] }));
});
//# sourceMappingURL=ChatSurface.js.map